export function toHttpError(error) {
  // Erro de rede/timeout
  if (!error.response) {
    let code = "NETWORK_ERROR";
    let message = "Sem conexão com o servidor.";

    if (error.code === "ECONNABORTED" || /timeout/i.test(error.message)) {
      code = "TIMEOUT_ERROR";
      message = "Tempo de conexão excedido.";
    }

    return {
      status: 0,
      code: code,
      message: error.message || error.detail || message,
      details: null,
      raw: error,
    }
  }
  const { status, data } = error.response
  return {
    status,
    code: data?.code || `HTTP_${status}`,
    message: data?.message || data?.detail || 'Erro ao comunicar com o servidor.',
    details: data?.errors || data || null,
    raw: error,
  }
}
